import { graphql } from "../__generated__/gql";

export const GET_GROUP_YEAR_QUERY = graphql(`
  query GetGroupYear($groupId: Int, $yearMin: Int, $yearMax: Int) {
    groupYear: groupYear(
      groupId: $groupId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      groupId
      year
      population
    }
  }
`);

export default GET_GROUP_YEAR_QUERY;
